import { render, staticRenderFns } from "./GenerateBadgesModal.vue?vue&type=template&id=7c40341f&"
import script from "./GenerateBadgesModal.vue?vue&type=script&lang=js&"
export * from "./GenerateBadgesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports